export default __webpack_public_path__ + "static/templogo-78a4cdb763befe99fa893fb33a999fbf.png";